import { validationHelper } from "../../../../common/helpers";
import { messages } from "../../../../common/constants";

export function validateOffer(values) {
  const errors = {};

  if (validationHelper.stringIsNullOrEmpty(values.name)) {
    errors.name = messages.MANDATORY_FIELD;
  }

  if (validationHelper.stringIsNullOrEmpty(values.expirationDate)) {
    errors.expirationDate = messages.MANDATORY_FIELD;
  }
  if (validationHelper.stringIsNullOrEmpty(values.startDate)) {
    errors.startDate = messages.MANDATORY_FIELD;
  }

  if (
    !validationHelper.stringIsNullOrEmpty(values.expirationDate) &&
    !validationHelper.stringIsNullOrEmpty(values.startDate)
  ) {
    if (values.expirationDate < values.startDate) {
      errors.expirationDate = messages.INVALID_DATE;
    }
  }
  return errors;
}

export function validateItem(values) {
  const errors = {};

  if (validationHelper.stringIsNullOrEmpty(values.id) || values.id == "0") {
    errors.id = messages.MANDATORY_FIELD;
  }

  if (validationHelper.stringIsNullOrEmpty(values.discount)) {
    errors.discount = messages.MANDATORY_FIELD;
  } else if (!validationHelper.isOffer(values.discount)) {
    errors.discount = messages.DECIMAL_FORMAT_FIELD;
  }

  if (validationHelper.stringIsNullOrEmpty(values.before_price)) {
    errors.before_price = messages.MANDATORY_FIELD;
  } else if (!validationHelper.isOffer(values.before_price)) {
    errors.before_price = messages.DECIMAL_FORMAT_FIELD;
  }

  if (validationHelper.stringIsNullOrEmpty(values.price)) {
    errors.price = messages.MANDATORY_FIELD;
  } else if (!validationHelper.isOffer(values.price)) {
    errors.price = messages.DECIMAL_FORMAT_FIELD;
  }

  return errors;
}



// WEBPACK FOOTER //
// ./src/scenes/Administration/Offer/OfferEdit/_validate.js